
import {ElLoading} from "element-plus";

const columnList: Array<column> = [
    {
        prop: "title",
        label: "事项名称",
        width: 66,
    },
    {
        prop: "type_text",
        label: "类型",
        width: 66,
    },
    {
        prop: "deal_text",
        label: "是否处理",
        width: 66,
    },
];
import {Request} from "@/api/request";
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    scheduleIndex,
    scheduleTypeListAPi
} from "@/api/http";
import {column} from "@/assets/types/common";
import {validateInput} from "@/assets/js/formRules";
import router from "@/router";
import {useRouter} from "vue-router";

export default defineComponent({
    name: "Vehicle",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["待办列表"]);
        let router = useRouter();
        let dialog_model = ref(false),
            selectInfo = ref('');
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            select_carId = ref(null),
            Router:any = useRouter(),
            headClass = inject("headClass"),
            params = reactive({
                type:'',
                is_deal:0
            }),
            scheduleTypeList = ref([
            
            ] as any),
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                console.log(currentPage.value);
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let data = {...params,page:currentPage.value,pagesize:pageSize.value};
                scheduleIndex(data).then((res:any)=>{
                    tableData.value = res.content.list;
                    total.value = res.content.total;
                    console.log("tableData===",res.content.list);
                    loading.value = false;
                });
            },
            columnChange = (item: any, type: number): void => {
            
            },
            exportChange = () => {
            
            },
            goDetail = (row:any)=>{
                dialog_model.value = true;
                selectInfo.value = row;
            },
            goDeal = (row:any)=>{
                if ([1,2,3,4].includes(row.type)){
                    //到期提醒跳转去保险到期提醒页面
                    Router.push({
                        path: '/customer/expire',
                    })
                }
            },
            markAsFollowed = (row:any)=>{
                // 标记为已跟进
                Request.axiosInstance({
                    url: "adminapi/CustomerService/markFollowed",
                    data: {
                        id: row.id,
                    },
                }).then((res: any) => {
                    if(res.status == 200){
                        getTableData();
                    }
                });
            },
            getScheduleTypeList = () => {
                scheduleTypeListAPi({}).then((res:any)=>{
                    scheduleTypeList.value = res.content.list;
                    console.log("scheduleTypeList===",scheduleTypeList.value);
                });
            },
            selectChange = (e: number): void => {
                // console.log(e);
                getTableData();
            };
        
        onMounted(() => {
            getScheduleTypeList();
            getTableData();
        });
        
        return {
            columnList,
            tableData,
            loading,
            columnChange,
            dialog_model,
            headClass,
            goDetail,
            goDeal,
            markAsFollowed,
            total,
            scheduleTypeList,
            handleSizeChange,
            handleCurrentChange,
            selectInfo,
            screen,
            params,
            currentPage,
            pageSize,
            selectChange,
            exportChange,
        };
    },
});
